var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconMoreActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 4.16667C11.667 3.25 10.917 2.5 10.0003 2.5C9.08366 2.5 8.33366 3.25 8.33366 4.16667C8.33366 5.08333 9.08366 5.83333 10.0003 5.83333C10.917 5.83333 11.667 5.08333 11.667 4.16667Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 15.8333C11.667 14.9166 10.917 14.1666 10.0003 14.1666C9.08366 14.1666 8.33366 14.9166 8.33366 15.8333C8.33366 16.75 9.08366 17.5 10.0003 17.5C10.917 17.5 11.667 16.75 11.667 15.8333Z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.667 10C11.667 9.08337 10.917 8.33337 10.0003 8.33337C9.08366 8.33337 8.33366 9.08337 8.33366 10C8.33366 10.9167 9.08366 11.6667 10.0003 11.6667C10.917 11.6667 11.667 10.9167 11.667 10Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonIconMoreActive);
export default __webpack_public_path__ + "static/media/common_icon_more_active.db6c2dd8fb5be9edb615814d1a5ff815.svg";
export { ForwardRef as ReactComponent };